/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const freshmail = () => {
  let newsletterForm = document.querySelector('.js-freshmail-form');

  if (newsletterForm) {
    let submitBtn = newsletterForm.querySelector('button[type="submit"]');

    let newQueryAjax = e => {
      e.preventDefault();

      if (newsletterForm.classList.contains('is-validated')) {
        newsletterForm.querySelector('.js-newsletter-agreements-error').classList.add('u-hidden');
        newsletterForm.querySelector('.js-newsletter-validation-success').classList.add('u-hidden');
        newsletterForm.querySelector('.js-newsletter-validation-error').classList.add('u-hidden');
      }

      let newsletterInput = document.querySelector('.js-freshmail-contact');

      let ajaxData = {
        action: 'send_contact_to_list',
        form_email: newsletterInput.value,
      };

      let ajaxParameters = Object.entries(ajaxData)
        .map(e => e.join('='))
        .join('&');

      /**
       * Ajax post
       */
      const ajax_url = document.querySelector('meta[name="ajax_url"]').content;
      let request = new XMLHttpRequest();
      request.open('POST', ajax_url, true);
      request.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded;',
      );
      request.onload = function () {
        console.log(ajaxData);
        console.log(this.response);
        if (newsletterForm.classList.contains('is-validated')) {
          if (this.response.status >= 200 && this.response.status < 400) {
            newsletterForm.querySelector('.js-newsletter-validation-success').classList.remove('u-hidden');
          }
          else {
            newsletterForm.querySelector('.js-newsletter-validation-error').classList.remove('u-hidden');
          }
        }
      };
      request.onerror = function () {
        console.log(ajaxData);
        console.error(this.response);
        if (newsletterForm.classList.contains('is-validated')) {
          newsletterForm.querySelector('.js-newsletter-validation-error').classList.remove('u-hidden');
        }
      };
      request.send(ajaxParameters);
    };

    /**
     * Listeners
     */
    newsletterForm.addEventListener('submit', newQueryAjax);
    submitBtn.addEventListener('click', (e) => {
      let agreements = newsletterForm.querySelectorAll('.js-toggleable-group input[required]');
      if (agreements) {
        agreements.forEach(agreement => {
          if (!agreement.checked) {
            newsletterForm.querySelector('.js-newsletter-agreements-error').classList.remove('u-hidden');
            return false;
          }
        });
      }
    });
  }
};

export default freshmail;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/freshmail.js